import React, { useState } from "react";
import BrokerageTab from "./BrokerageTab";
import BrokersTab from "./BrokersTab";
import ProspectsTab from "./ProspectTab";
import PolicyTab from "./PolicyTab";
import "./QuoteyDashboard.css";

const QuoteyDashboard = () => {
  const [activeTab, setActiveTab] = useState("brokerages");
  
  // --- NEW: State for date filters ---
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
  };

  return (
    <div className="dashboard-container">
      <h1>Quotey Dashboard</h1>
      
      {/* --- NEW: Global filter section for dates --- */}
      {/* <div className="global-filters">
        <div className="filter-group">
          <label htmlFor="start-date">Start Date</label>
          <input
            id="start-date"
            type="date"
            className="filter-date-input"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div className="filter-group">
          <label htmlFor="end-date">End Date</label>
          <input
            id="end-date"
            type="date"
            className="filter-date-input"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <button onClick={handleClearDates} className="clear-button">Clear Dates</button>
      </div> */}

      <div className="dashboard-tabs">
        <button
          className={`tab-button ${activeTab === 'brokerages' ? 'active' : ''}`}
          onClick={() => setActiveTab('brokerages')}
        >
          Brokerages
        </button>
        <button
          className={`tab-button ${activeTab === 'brokers' ? 'active' : ''}`}
          onClick={() => setActiveTab('brokers')}
        >
          Brokers
        </button>
        <button
          className={`tab-button ${activeTab === 'prospects' ? 'active' : ''}`}
          onClick={() => setActiveTab('prospects')}
        >
          Prospects
        </button>
        <button
          className={`tab-button ${activeTab === 'policy' ? 'active' : ''}`}
          onClick={() => setActiveTab('policy')}
        >
          Policy
        </button>
      </div>

      {/* --- UPDATED: Pass dates as props to the active tab --- */}
      {activeTab === 'brokerages' && <BrokerageTab startDate={startDate} endDate={endDate} />}
      {activeTab === 'brokers' && <BrokersTab startDate={startDate} endDate={endDate} />}
      {activeTab === 'prospects' && <ProspectsTab startDate={startDate} endDate={endDate} />}
      {activeTab === 'policy' && <PolicyTab startDate={startDate} endDate={endDate} />}
    </div>
  );
};

export default QuoteyDashboard;